
import path from "path";

export default {
  name: "news",
  props: ["source", "index"],
  data() {
    return {};
  },
  watch: {
    source(val) {
      this.source = val;
    },
  },
};
